import {InstallPWAButton} from './InstallPWAButton'

export default InstallPWAButton
